import React, {useEffect} from "react";
import SubHeader from "../../components/header/SubHeader";
import {useDispatch, useSelector} from "react-redux";
import {getTableColumns, getTableData} from "../../models/customerModel";
import Table from "../../components/common/table/Table";
import ActionDropdown from "../../components/actions/ActionDropdown";
import {deleteCustomer, fetchCustomers, resetCreateStatus, resetUpdateStatus} from "../../store/customer-slice";
import {useSearchParams} from "react-router-dom";
import Button from "../../components/common/button/Button";
import {onClearFilter} from "../../store/view-order-filter-slice";

const CustomerView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        error,
        pagination
    } = useSelector(state => state.customer); // Updated to customer slice

    const userRole = useSelector((state) => state.auth.selectedRole);
    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    useEffect(() => {
        dispatch(fetchCustomers({
            ...userRole,
            page: initialPage,
            limit: initialLimit
        }));
        dispatch(onClearFilter());
    }, [dispatch, userRole, initialPage, initialLimit]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    const deleteHandler = (id) => {
        dispatch(deleteCustomer({...userRole, id})); // Updated action
    };

    const tableColumns = getTableColumns({ActionDropdown, deleteHandler});
    const tableData = getTableData({items});

    return (
        <>
            <SubHeader title="All Customers">
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <Table
                    className="mobile-responsive"
                    columns={tableColumns}
                    data={tableData}
                    pagination={pagination}
                />
            )}
        </>
    );
};

export default CustomerView;
